export default function AboutMe() {
    return (
        <section id="AboutMe" className="about--section">
            <div className="about--section-image">
                <img src="./img/me1.png" alt="AboutMe"/>
            </div>

            <div className="hero--section--content--box about--section--box">
                <div className="hero--section--content">
                <p className="section--title">About Me</p>
                <h2 className="skills-section--heading">Consistently Reliable, Committed to Excellence</h2>
                <p className="hero--section-description">
                    As a dedicated Computer Science and Linguistics student at Boston University, 
                    I've actively contributed to the academic community as a Teaching Assistant for the Introduction to Computer Systems course.
                    My tenure here has also been enriched by hands-on experience in diverse personal and group projects. 
                    Through these projects, I've honed a comprehensive skill set encompassing both FrontEnd and BackEnd development, 
                    fostering a deep understanding of the intricacies of software development.
                </p>
                <p className="hero--section-description">
                    Outside of school, I find joy in practicing Martial Arts and participating in Chinese Lion Dancing festivities during events.
                </p>
                </div>
            </div>
            
        </section>
    )
}